<div class="card-actions">
  <button
    *roleVisibility="['update']; classNames: ['BeneOA']"
    type="button"
    mat-raised-button
    (click)="showAddNewChildrenHandler()">
    Aggiungi scheda figlia
  </button>
</div>

<ui-table
  *ngIf="pager$ | async as pager"
  [rowSelection]="'checkbox'"
  [fields]="fields"
  [pager]="pager"
  [reload]="reload$"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="50"
  [contextMenuActions]="contextMenus"
  (select)="selectHandler($event)"
  (itemsPageChange)="applyChangePageHandler($event)">
</ui-table>
